import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./home";
import { useAuth0 } from "@auth0/auth0-react";
import Layout from "../components/layout";
import Activity from "./activity";
import Settings from "./settings";
import Profile from "./profile";
import Transaction from "./transaction";
import Integration from "./integration";
import BankAccount from "./bankaccount";
import Accounts from "./tranference/accounts";
import { Withdrawals } from "./tranference/withdrawals";
import WithdrawalsHistory from "./withdrawalsHistory";
import Wordpress from "./integration/wordpress";
import Registration from "./registrationProfile";
import BankTransfer from "./transfer";
import { BlackListCard } from "./blacklistCard";

const AppRoutes: React.FC = () => {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div className="page-layout">
        cargando....
        {/* <PageLoader /> */}
      </div>
    );
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/activity" element={<Activity />} />
        {/* <Route path="/profile" element={<Profile />} /> */}
        <Route path="/perfil" element={<Profile />} />
        <Route path="/transacciones" element={<Transaction />} />
        <Route path="/transferencias/cuentas" element={<Accounts />} />
        <Route path="/transferencias/retiros" element={<Withdrawals />} />
        <Route
          path="/transferencias/historial"
          element={<WithdrawalsHistory />}
        />

        <Route path="/configuraciones" element={<Settings />} />
        <Route path="/bankaccount" element={<BankAccount />} />
        <Route path='/transferencias-bancarias' element={<BankTransfer/>}/>
        <Route path="/integraciones" element={<Integration />} />
        <Route path="/integraciones/wordpress" element={<Wordpress />} />
        <Route path="/integraciones/api" element={<Wordpress />} />
        <Route path="/tarjetas" element={<BlackListCard/>}/>
      </Route>

      <Route path="/completar-perfil" element={<Registration />}></Route>
    </Routes>
  );
};

export default AppRoutes;
